import React from "react";

interface SubItemsIconProps {
  color?: string;
  width?: number;
  height?: number;
}

export const SubItemsIcon: React.FC<SubItemsIconProps> = ({ color = "#7F869B", width = 13, height = 13 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 13 13">
      <path
        fill={color}
        d="M2.542.11a.424.424 0 0 1 0 .847h-.636v3.39h4.8V3.64c0-.39.317-.706.706-.706h4.378c.39 0 .705.316.705.706V5.9c0 .389-.315.705-.705.705H7.412a.707.707 0 0 1-.706-.706v-.706h-4.8v4.8h4.8v-.707c0-.39.317-.706.706-.706h4.378c.39 0 .705.316.705.706v2.26c0 .39-.315.706-.705.706H7.412a.707.707 0 0 1-.706-.706v-.706H1.482a.424.424 0 0 1-.423-.424V.957H.424a.424.424 0 0 1 0-.848zm5.012 11.295h4.094V9.43H7.554zm0-5.646h4.094V3.782H7.554z"
      />
    </svg>
  );
};
